<template>
  <div class="order">
    <van-nav-bar
      :fixed="true"
      title="确认订单"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div
      class="address"
      @click="add"
    >
      <p class="top"><span class="name">{{address.name}}</span><span>{{address.tel}}</span></p>
      <p class="bottom">{{address.address}}</p>
      <div class="more">
        <van-icon
          name="arrow"
          size='0.5rem'
          color="#888"
        />
      </div>

    </div>
    <!-- <div class="">
      <img
        src="../../assets/bottom-bj.jpg"
        alt=""
      ></div> -->
    <div class="datails">
      <div class="shop">HKJ·{{shopname}}</div>
      <div class="top">
        <div
          class="card "
          v-for="(v,i) in goods"
          :key="i"
        >
          <van-card>
            <template #thumb>
              <img
                class="imgs"
                :src="v.sku_thumb"
                alt=""
              >
            </template>
            <template #title>
              <div class="title">{{v.name}}</div>
            </template>
            <template #price>
              <div class="price">￥{{v.show_price}}</div>
            </template>
          </van-card>
          <div class="close">
            x {{v.goods_num}}
          </div>
          <div v-show="v.zengpin" class="zeng">额外赠送{{v.give+v.units}}</div>
        </div>

        <div
          class="details"
          v-show="true"
        >

        </div>
           
        <div
          class="num"
        >
           <!-- v-show="uid==7360" -->
        <!-- [3,51,56,22].indexOf($store.state.shopid)!=-1  -->
          <p>鲸点返利 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
     <!-- v-show="uid==7360" -->
          
          <div class="more">
            <p></p>
            <!-- <van-checkbox v-if="uid==7360" :disabled='+fanm<=0' label-position="left" @click='fans()' v-model="radio" checked-color="#ee0a24">{{fanm>0?'账户余额'+fanqm+'元，本单可用'+fanm+'元':'暂无返利可用'}}</van-checkbox> -->
  <van-checkbox :disabled='+fanm<=0 ' label-position="left" @click='fans()' v-model="radio" checked-color="#ee0a24">{{fanm>0?'账户余额'+fanqm+'元，本单可用'+fanm+'元':'暂无返利可用'}}</van-checkbox>
  <!-- <van-checkbox :disabled='+fanm<=0 || vip' label-position="left" @click='fans()' v-model="radio" checked-color="#ee0a24">{{fanm>0?'账户余额'+fanqm+'元，本单可用'+fanm+'元':'暂无返利可用'}}</van-checkbox> -->
          </div>
        </div>
            <!-- <div
          class="num"
     v-show="uid==7360"
        >
          <p>积分抵扣 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
          
          <div class="more">
            <p></p>
  <van-checkbox :disabled='fanm<=0' label-position="left" @click='fans()' v-model="radio" checked-color="#ee0a24">{{fanm>0?'当前可抵扣￥'+fanm:'暂无积分可用'}}</van-checkbox>
          </div>
        </div> -->
        <div
          class="num"
          @click="coupon"
          v-show="$store.state.ptf==1"
        >
          <p>优惠劵</p>
          <span> 
            <van-icon v-show="coupon_txt=='有可用优惠券'" class="hb" name="bill" />
             {{coupon_txt}}
          </span>

          <div class="more">
            <van-icon
              name="arrow"
              size='0.5rem'
              color="#888"
            />
          </div>
        </div>
        <div
          class="num"
          @click="delivery"
        >
          <p>物流方式</p>
          <span>{{delivery_txt?delivery_txt:'请选择配送方式'}}</span>
          <div class="more">
            <van-icon
              name="arrow"
              size='0.5rem'
              color="#888"
            />
          </div>
        </div>
        <div v-show="false" class="">
        <div
          class="num"
        >
           <!-- v-show="uid==7360" [1,3,51,56].indexOf($store.state.shopid)!=-1 -->
        <!-- [3,51,56,22].indexOf($store.state.shopid)!=-1  -->
          <p>整单折扣 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
   
          
          <div class="more">
            <p></p>
           
    <van-checkbox  label-position="left" @click='zhe()' v-model="radio1" checked-color="#ee0a24">{{'是否使用整单折扣'}}</van-checkbox>
 
          </div>
        </div>
        <!-- <div
          class="num"
        >
          <p>订单类型 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>    
          <div class="more">
            <p style="padding-right: 0.4rem;">{{ radio1 ? 'N-t-s':'Y-t-s'}}  </p>
           
          </div>
        </div>
        <div
          class="num"
        >
          <p>是否开票 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
          <div class="more">
            <p style="padding-right: 0.4rem;">{{ radio1 ? '否':'是'}}  </p>
           
          </div>
        </div> -->
      </div>
        <!-- 发票 -->
        <!-- <div
          class="num"
          @click="invoice"
        >
          <p>是否开具发票</p>
          <span>{{invoice_txt}}</span>
          <div class="more">
            <van-icon
              name="arrow"
              size='0.5rem'
              color="#888"
            />
          </div>
        </div> -->
        <!-- <div
          v-show="taxf"
          class="num"
          @click="tax"
        >
          <p>开票信息目录</p>
          <span>{{tax_info?tax_info.username:""}}</span>
          <div class="more">
            <van-icon
              name="arrow"
              size='0.5rem'
              color="#888"
            />
          </div>
        </div> -->
         <!-- <div
          class="num"
     v-show="[1,22,3,51].indexOf(shopid)!=-1"
        >
          <p>是否使用鲸点抵扣 &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
          
          <div class="more">
            <p></p>
  <van-checkbox label-position="left" @click='fans()' v-model="radio" checked-color="#ee0a24">当前可抵扣￥{{fanm}}</van-checkbox>
          </div>
        </div> -->
        
        <div class="v_field">
          <p>买方留言：</p>

          <textarea
            v-model="txt"
            class="field"
            maxlength=95
            placeholder="选填：留言请在45字之内"
            @change="text"
          ></textarea>
        </div>
      
        <div class="prices">
          <div class="p_num"> 共计：<span>{{num}}</span>件商品</div>
        </div>
        <div class="statistics">
          <div class="num">
            <p>货物总金额</p>
            <span>￥{{actualmoney.toFixed(2)}} </span>
          </div>
          <div class="num" >
            <p>- 鲸点返利</p>
            <span> ￥{{fan}} </span>
          </div>
         
          <div class="num">
            <p>- 优惠劵</p>
            <span> ￥{{coupon_money}} </span>
          </div>
           <!-- <div class="num" v-show="uid==7360">
            <p>积分抵扣</p>
            <span>- ￥{{fan}} </span>
          </div> -->
           <div class="num">
            <p>+ 运费</p>
            <span> ￥{{delivery_money}} </span>
          </div>
          <div class="num" >
            <p>- 整单折让</p>
            <span> ￥{{ zheq }} </span>
          </div>
          <div class="num" >
            <p></p>
            <span>总共节省：￥{{(Number(fan)+Number(coupon_money)+Number(zheq)).toFixed(2) }} </span>
          </div>
        </div>

      </div>
      <div class="buts">

        <div class="but">
          <div class="money">
            本单应付款：￥{{ actual_money}}

          </div>

          <van-button
            :disabled='bflage'  
            type="danger"
            size="large"
            class="v_but"
            @click="buy"
          >确认订单</van-button>

        </div>
      </div>
    </div>
    <!-- 优惠劵弹出层 -->
    <van-popup
      v-model="coupon_show"
      position="bottom"
      style="height: 70%; padding-top: 4px;"
    >
      <coupon
        @coupon="coupon_use"
        :list="coupon_list"
      ></coupon>
    </van-popup>
    <!-- 配送弹出层 -->
    <van-popup
      v-model="delivery_show"
      position="bottom"
      style="height: 80%; padding-top: 4px;"
    >
      <delivery
        :f_money='freightinfo'
        :fm="actualmoney"
        v-if="freightinfo"
        @delivery="delivery_use"
      ></delivery>
    </van-popup>
    <van-popup
      v-model="tax_show"
      position="bottom"
      style="height: 70%; padding-top: 4px;"
    >
      <tax @tax="tax_use"></tax>
    </van-popup>
    <!-- fap -->
    <van-action-sheet
      v-model="invoice_show"
      :actions="actions"
      @select="onSelect"
    />
    <div
      class="meng"
      v-show="mshow"
    >
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Coupon from './child/coupon'
import Delivery from './child/delivery'
import Tax from './child/tax'
import {
  NavBar,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Toast,
  Icon,
  Card, Stepper, Button, Field, Popup,
  ActionSheet,
  Loading, Dialog, Checkbox, CheckboxGroup
} from 'vant'

Vue.use(NavBar)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast).use(Icon)
  .use(Card)
  .use(Stepper)
  .use(Button).use(Field).use(Popup).use(ActionSheet)
  .use(Loading).use(Dialog).use( Checkbox).use( CheckboxGroup)
export default {
  created () {
    this.vip = JSON.parse(localStorage.getItem('vip')).id == 1 ?   false:true

    if (this.$route.params.money) {
      this.$store.state.amoney = this.$route.params.money
    } else {
    }
    this.txt = sessionStorage.getItem('txt')
    // console.log(this.$route.params)
    // this.goods = this.$route.params.goods ? this.$route.params.goods : this.$store.state.goods
    if (this.$route.params.goods) {
      this.goods = this.$route.params.goods
      this.$store.state.goods = this.$route.params.goods
      this.shopid = this.$route.params.shopid
      this.$store.state.oid = this.$route.params.shopid
      this.shopname = this.$route.params.shopname
      this.$store.state.oname = this.$route.params.shopname
      this.shoptype = this.$route.params.type
      this.$store.state.otype = this.$route.params.type
    } else {
      this.goods = this.$store.state.goods
      this.shopid = this.$store.state.oid
      this.shopname = this.$store.state.oname
      this.shoptype = this.$store.state.otype
    }
    // console.log(this.shopid)
    this.axios.post('storeModel', { store_id: this.shopid }).then(res => {
      // console.log(res)
      this.fal = res.data.info
      // console.log(this.fal)
      if (this.fal == 2) {
        this.invoice_txt = '不需要开票'
        // console.log(this.invoice_txt)

      }
    }).catch(ref => { })
    this.goods.forEach(v => {
      this.num += v.goods_num
    })
    this.getcoupon()

    this.actualmoney = this.$route.params.money ? this.$route.params.money : this.$store.state.amoney
    this.actualmoney.toFixed(2)
    this.nomoney = this.$route.params.money ? this.$route.params.money : this.$store.state.amoney
    this.nomoney.toFixed(2)

    // console.log(this.nomoney)
    if (this.$route.params.address) {
      this.address = this.$route.params.address
      this.address_id = this.$route.params.address.id
      this.$store.state.s_address = this.$route.params.address}
    // } else if (this.$store.state.s_address) {
    //   this.address = this.$store.state.s_address
    //   this.address_id = this.$store.state.s_address.id
    // }
    else {
      // this.getaddress()
    }
    
      this.uid=JSON.parse(localStorage.getItem('user')).id
      this.axios.get('getFanliMoney',{ params: { store_id: this.shopid } }).then(res => {
        if(res.data.code==200){
          this.fanm=this.actualmoney*res.data.data.rate<=res.data.data.money?(this.actualmoney*res.data.data.rate).toFixed(2):res.data.data.money
          this.fanqm=res.data.data.money
        }
        
      }).catch(ref => {
      })
      this.axios.post('userInfo', { store_id: this.shopid } ).then(res => {
        if(res.data.code==200){
          console.log(res.data.info) 
          this.zhex = res.data.info.user_bill_tax
          this.usid=res.data.info.store_id
        }
        
      }).catch(ref => {
      })

  },
  mounted(){
 
   
  },
  data () {
    return {
      uid:1,
      usid:1,
      goods: [],
      shopid: '',
      bflage:false,
      shopname: '',
      shoptype: '',
      taxf: false,
      coupon_show: false, //优惠劵显示
      coupon_list: [], //优惠劵
      coupon_money: 0,//优惠金额
      coupon_txt: '暂无优惠劵',//优惠金额
      coupon_id: '',//优惠金额
      delivery_show: false,
      delivery_money: '',
      delivery_txt: '',
      tax_show: false,
      tax_info: "",
      invoice_txt: '',
      invoice_show: false,
      actions: [{ name: '不需要开票' }, { name: '增值普通发票' }, { name: '增值税专用发票' },],
      num: 0,
      actualmoney: 0,
      txt: '',
      address: { name: '请选择地址', address: "", tel: "" },
      address_id: "",
      freightinfo: '',
      mshow: false,
      fal: '',
      nomoney: 0,
      radio:false,
      radio1: false,
      zhex: 1,
      zheq:0,
      fanm:0,
      fanqm:0,
      fan:0,
      vip:true

    }
  },
  computed: {
    actual_money () {
      let money = 0
      // money = (this.$route.params.money - this.coupon_money ? this.coupon_money : 0 + this.delivery_money ? this.delivery_money : 0
      // ).toFixed(2)
      money = Number(this.actualmoney - this.coupon_money + Number(this.delivery_money)-this.fan-this.zheq).toFixed(2)
      return money
    },
  },
  watch: {

  },
  methods: {
      fans(){
      if(this.radio){
        this.fan=this.fanm
      }else{
       this.fan=0
      }
     this.fan= Number(this.fan).toFixed(2)
      // console.log(this.fan)
      // console.log(this.coupon_money)
    },
    zhe () {
      if (this.radio1) {
        // console.log(1-this.zhex)
        this.zheq=this.usid==1? this.actualmoney*(1-this.zhex):0
      }else{
       this.zheq=0
      }
      this.zheq = Math.floor(Number(this.zheq) * 100) / 100;
    
    },
    getaddress () {
      this.axios.get('listAddress').then(res => {
        // console.log(res)
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.getlist()
        }
        if (res.data.code == 200) {
          res.data.data.forEach(v => {
            if (v.is_default == 1) {
              this.address.name = v.realname
              this.address.address = v.prov + v.city + v.dist + v.address_detail
              this.address.mobile = v.mobile
              this.address_id = v.id
            }
          })

        }
      }).catch(ref => {
      })


    },
    getcoupon () {
      // return false
      this.axios.post('condition_coupon', { money: this.$store.state.amoney, store_id: this.shopid }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.getcoupon()
        }

        if (res.data.code == 200) {
          this.coupon_list = res.data.data.sort((a, b) => {
            return b.money - a.money
          })
          this.coupon_txt = "有可用优惠券"
        } else {

        }
      }).catch(ref => {
        console.log(ref)
      })

      this.axios.post('list_freight ', { store_id: this.shopid }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.getcoupon()
        }
        if (res.data.code == 200) {
          this.freightinfo = res.data.data

        } else {

        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    onClickLeft () {
      // if (this.$route.query.name) {
      //   this.$router.push(this.$route.query.name)
      // } else {
      //   this.$router.go(-1)
      // }
      this.$router.go(-1)
      // this.$router.push({ name: 'product', params: { goodsid: 0 } })

    },
    onEdit (item, index) {
      Toast('编辑地址:' + index);
    },
    add () {
      // this.num = this.num + 1
      // console.log(this.$store.state.shopname)
      if (this.$store.state.shopname) {

      } else {
        this.$store.commit('adds', this.goods)
        // this.$store.state.shopname = this.$route.params.shopname
        this.$store.state.money = this.$route.params.money
      }

      this.$router.push({ name: 'optads', query: { name: 'order' }, params: { id: 1 } })
    },
    coupon () {
      if (this.coupon_list.length) {
        this.coupon_show = true
      }

    },
    coupon_use (v) {
      // console.log(v)
      this.coupon_show = false
      if (v) {
        this.coupon_money = v.money
        this.coupon_txt = v.name
        this.coupon_id = v.id

      }
    },
  
    tax () {
      this.tax_show = true
    },
    tax_use (v) {
      this.tax_show = false
      this.tax_info = v
    },
    delivery () {
      this.delivery_show = true
    },
    delivery_use (v) {
      this.delivery_show = false
      this.delivery_money = v.freight
      this.delivery_txt = v.way
    },
    invoice () {
      if (this.fal == 2) {
        return false
      }
      this.invoice_show = true
    },
    onSelect (item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起

      this.invoice_show = false;
      this.invoice_txt = item.name
      if (this.invoice_txt == '不需要开票') {
        // console.log(this.fal)
        if (this.fal == 1) {
          // Toast('您现在的订单是含票订单，但您选择不开票')
          Dialog.alert({
            message: '您的订单类型为含税销售，您当前选择的是不开发票，请您再次确认！',
            confirmButtonText: "确 认"
          }).then(() => {
            // on close
          });
        }
        this.taxf = false

      } else {
        // this.$router.push({ name: 'optads2', query: { name: 'order2' }, params: { id: 1 } })
        // Toast("请备注发票收货地址和联系人")
        // if (this.fal == 2) {
        //   Toast('您现在的订单是不含票订单，但您选择开票')
        // }
        this.taxf = true
      }
    },
    text () {
      sessionStorage.setItem("txt", this.txt)
    },
    buy () {
      // console.log(this.goods)
      this.bflage=true
      // return false 
      let arg=[]
      this.goods.forEach(v=> {
        arg.push({goods_name:v.name,goods_num:v.goods_num,id:v.attr_id})
      })
       this.axios.post('account', { goods:arg }).then(res => {
        if (res.data.code == 2000) {
          this.mshow = false
          Toast(res.data.data + res.data.msg)
      this.bflage=false

          return false
        }             
      if (this.address_id) {
      } else {
        Toast("请选择地址")
      this.bflage=false

        return false
      }
      let t = ""
      if (this.invoice_txt == '不需要开票') {

        t = 1
      } else {
        t = 2
        // if (this.tax_info == "") {
        //   Toast("请选择发票收货地址和联系人")
        //   return false
        // }
      }
      // gailia
      if (this.delivery_txt) {
        sessionStorage.setItem("txt", '')
        // console.log(this.shoptype)
        this.mshow = true
      this.bflage=true

        // return false
        if (this.shoptype == 1) {
      
          this.axios.post('addByCart', { address_id: this.address_id, freight_type: this.delivery_txt, freight: this.delivery_money, goods: this.goods, coupon_id: this.coupon_id, all_money: this.$store.state.amoney, store_id: this.shopid, tax_type: t, tax: this.invoice_txt, tax_info: this.tax_info.id, remarks: this.txt, actual_money: this.actual_money, total_price: this.nomoney,fan:this.fan,discount:this.radio1?1:0,discount_money:this.zheq }).then(res => {
            
            // console.log(res)
            //   return false
            if (res.data.code == 200) {
              this.mshow = false

              this.$router.push({ name: 'cashier', query: { money: this.actual_money, sid: this.shopid,order:res.data.orderId } })
            } else {
              this.mshow = false
              this.bflage=false

              Toast(res.data.msg)
            }
          }).catch(ref => {
              this.bflage=false

            this.mshow = false
          })
        } else {
        // return false
        if(this.goods[0].tf){
          this.axios.post('addByDirectsankeshu', {taocan:this.goods[0].tc, address_id: this.address_id, freight_type: this.delivery_txt, freight: this.delivery_money, goods: this.goods, coupon_id: this.coupon_id, all_money: this.$store.state.amoney, store_id: this.shopid, tax_type: t, tax: this.invoice_txt, tax_info: this.tax_info.id, remarks: this.txt, actual_money: this.actual_money, total_price: this.nomoney,fan:this.fan,discount:this.radio1?1:0,discount_money:this.zheq }).then(res => {
            
            // console.log(res)

            if (res.data.code == 200) {
              this.mshow = false

              this.$router.push({ name: 'cashier', query: { money: this.actual_money, sid: this.shopid,order:res.data.orderId } })
            } else {
              this.mshow = false

              Toast(res.data.msg)
            }
          }).catch(ref => {
              this.bflage=false

            this.mshow = false
          })

        }else{

    this.axios.post('addByDirect', {jianlou:this.goods[0].jianlou,ispintuan:this.goods[0].ispintuan,isddt_price:this.goods[0].isddt_price, address_id: this.address_id, freight_type: this.delivery_txt, freight: this.delivery_money, goods: this.goods, coupon_id: this.coupon_id, all_money: this.$store.state.amoney, store_id: this.shopid, tax_type: t, tax: this.invoice_txt, tax_info: this.tax_info.id, remarks: this.txt, actual_money: this.actual_money, total_price: this.nomoney,fan:this.fan,discount:this.radio1?1:0,discount_money:this.zheq }).then(res => {
            
            // console.log(res)
            //   return false

            if (res.data.code == 200) {
              this.mshow = false
             
              this.$router.push({ name: 'cashier', query: { money: this.actual_money, sid: this.shopid,order:res.data.orderId } })
            } else {
              this.mshow = false
              Toast(res.data.msg)
            }
          }).catch(ref => {
            this.mshow = false
          })
        }
          
        }

      }
      else {
        Toast('请选择配送方式')
      this.bflage=false

      }
       }).catch(ref => {
      this.bflage=false

      })
    },
    
    
  },
  components: {
    Coupon,
    Delivery,
    Tax
  }
}
</script>
<style lang="less">
.van-button__text {
  font-size: 0.4rem;
}
</style>
<style lang='less' scoped>
.meng {
  position: fixed;
  width: 100%;
  height: 93%;
  left: 0;
  text-align: center;
  top: 1.3333rem;
  padding-top: 70%;
  background-color: rgba(151, 150, 150, 0.3);
  z-index: 999;
}
.order {
  padding-top: 1.333333rem;
  background-color: #f1f1f1;
}
.address {
  position: relative;
  padding: 0.4rem;
  width: 100%;
  height: 2rem;
  background-color: #fefcee;
    background: url(../../assets/my/ot.jpg) no-repeat center;
   background-size: 100% 100%;
  .top {
    height: 0.76rem;
    .name {
      padding-right: 1rem;
      font-size: 0.426667rem;
    }
  }
  .bottom {
    font-size: 0.373333rem;
    // color: #888;
  }
}
.more {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.datails {
  margin-top: 0.266667rem;
  background-color: #fff;
  .shop {
    padding: 0.426667rem;
    color: #a22d2b;
    font-size: 0.426667rem;
    border-bottom: 0.03rem solid #dfdfdd;
  }
  .top {
    position: relative;
    background-color: #fff;
    width: 100%;
    padding-bottom: 2.3rem;
    .card {
      border-bottom: 0.03rem solid #dfdfdd;
      .van-card {
        background-color: #fff;
        padding-bottom: 0;
      }

      width: 100%;
      position: relative;
      padding-top: 0.2rem;
    }
    .title {
      padding-top: 0.2rem;
      font-size: 0.34rem;
    }
    .imgs {
      width: 2rem;
      height: 2rem;
    }
    .price {
      color: #e02828;

      font-size: 0.5rem;
      padding-bottom: 0.64rem;
    }
    .close {
      font-size: 0.5rem;
      // color: #d3d;
      position: absolute;
      right: 5%;
      top: 50%;
      background-color: #fff;
    }
    .zeng{
      color: rgb(245, 42, 42);
      text-align: right;
      padding-right: 5%;
      font-size: 0.38rem;

    }
    .num {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      display: flex;
      position: relative;
      span {
        text-align: right;
        width: 5rem;
        overflow: hidden; /*超过部分不显示*/
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 0.85rem;
        font-size: 0.35rem;
        padding-right: 10%;
        .hb{
  color: rgb(248, 43, 43);
  font-size: 0.5rem;
  top: 0.15rem;
  // line-height: 1rem;
  // padding-top: 0.2rem;
}
      }
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
        flex: 1;
      }
      .stepper {
        flex: 1;
        text-align: right;
      }
    }
    .v_field {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
      }
      .field {
        background-color: #f1f1f1;
        width: 100%;
        border: none;
        height: 1.2rem;
        text-indent: 0.2rem;
        resize: none;
        padding-top: 0.2rem;
      }
    }
    .prices {
      padding: 0.35rem 2.5rem;
      text-align: right;
      .p_num {
        // font-size: 0.4rem;
        color: #666;
        span {
          // font-size: 0.48rem;
          color: #a22d28;
          // padding-right: 0.5rem;
        }
      }
    }
  }
  .statistics {
    background-color: #dfdfdf;
    // margin-top: 1rem;
    height: 4.5rem;
    width: 100%;
    padding-top: 0.2rem;
    .num {
      border: none;
      padding: 0 0 0 0.3rem;
      background-color: #fff;
      span {
        color: #d0111b;
      }
    }
  }
  .buts {
    width: 100%;
    position: fixed;
    bottom: 0;
    border-top: 0.03rem solid #dfdfdf;
    background-color: #fff;
  }
  .but {
    display: flex;
    .money {
      font-size: 0.4rem;
      text-align: right;
      line-height: 1.3rem;
      padding-right: 0.5rem;
      flex: 1;
    }
    .v_but {
      flex: 0.6;
    }
  }
}
</style>